import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// withXSRFToken:false → axios never reads document.cookie (which throws in the sandboxed
// Wix iframe). Our backend uses Bearer / httpOnly cookies, not XSRF tokens.
const api = axios.create({ baseURL: API_BASE, withCredentials: true, withXSRFToken: false });

// localStorage access throws (SecurityError) inside a sandboxed iframe (e.g. the Wix
// custom element sandbox / opaque origin). Guard every access so the app still boots.
function safeStorageGet(key) {
  try { return typeof localStorage !== "undefined" ? localStorage.getItem(key) : null; } catch { return null; }
}
function safeStorageSet(key, value) {
  try { if (typeof localStorage !== "undefined") localStorage.setItem(key, value); } catch { /* sandboxed */ }
}
function safeStorageRemove(key) {
  try { if (typeof localStorage !== "undefined") localStorage.removeItem(key); } catch { /* sandboxed */ }
}

const savedToken = safeStorageGet("cf_token");
if (savedToken) api.defaults.headers.common["Authorization"] = `Bearer ${savedToken}`;

export function setAuthToken(token) {
  if (token) {
    safeStorageSet("cf_token", token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    safeStorageRemove("cf_token");
    delete api.defaults.headers.common["Authorization"];
  }
}

export function assetUrl(path) {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  return `${BACKEND_URL}${path}`;
}

// Separate client for buyer (shopper) auth on the public storefront — never sends the owner token.
export const shopApi = axios.create({ baseURL: API_BASE, withCredentials: false, withXSRFToken: false });
shopApi.interceptors.request.use((cfg) => {
  const t = safeStorageGet("hephy_buyer_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
export function setBuyer(token, buyer) {
  if (token) { safeStorageSet("hephy_buyer_token", token); safeStorageSet("hephy_buyer", JSON.stringify(buyer || {})); }
  else { safeStorageRemove("hephy_buyer_token"); safeStorageRemove("hephy_buyer"); }
}
export function getBuyer() {
  const t = safeStorageGet("hephy_buyer_token");
  if (!t) return null;
  try { return JSON.parse(safeStorageGet("hephy_buyer") || "{}"); } catch { return {}; }
}

// Separate client for team member (seller/marketing) auth — never sends the owner token.
export const teamApi = axios.create({ baseURL: API_BASE, withCredentials: false, withXSRFToken: false });
teamApi.interceptors.request.use((cfg) => {
  const t = safeStorageGet("hephy_team_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
export function setTeamMember(token, member) {
  if (token) { safeStorageSet("hephy_team_token", token); safeStorageSet("hephy_team", JSON.stringify(member || {})); }
  else { safeStorageRemove("hephy_team_token"); safeStorageRemove("hephy_team"); }
}
export function getTeamMember() {
  const t = safeStorageGet("hephy_team_token");
  if (!t) return null;
  try { return JSON.parse(safeStorageGet("hephy_team") || "{}"); } catch { return {}; }
}

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Algo salió mal";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export default api;
